import { useEffect, useMemo, useRef } from 'react';
import debounce from 'lodash-es/debounce';
import type { DebouncedFunc } from 'lodash-es/debounce';

export function useRefDebounce<T extends unknown[]>(
    callback: (...args: T) => void,
    delay: number,
): DebouncedFunc<(...args: T) => void> {
    const ref = useRef<(...args: T) => void>();

    useEffect(() => {
        ref.current = callback;
    }, [callback]);

    return useMemo(
        () =>
            debounce(
                (...args): void => {
                    ref.current?.(...args);
                },
                delay,
                { leading: false, trailing: true },
            ),
        [],
    );
}
